import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc
} from "firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL
} from "firebase/storage";
import { onAuthStateChanged } from "firebase/auth";
import { compressImage } from "../../utils/compressImage";


import { auth, db, storage } from "../Config/firebase";
import Navbar from "../Components/Navbar/navbar";
import { aplicarTenantAtual } from "../Utils/tenant";

export default function KPIEventoForm() {
  const { kpiId } = useParams();
  const history = useHistory();
  const [authChecked, setAuthChecked] = useState(false);
  const [classificacaoNC, setClassificacaoNC] = useState("");



  const [kpi, setKpi] = useState(null);
  const [loadingKpi, setLoadingKpi] = useState(true);
  const [erro, setErro] = useState(null);

  const [tipoRegistro, setTipoRegistro] = useState("");
  const [descricao, setDescricao] = useState("");
  const [imagem, setImagem] = useState(null);

  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const [authReady, setAuthReady] = useState(false);

  /* =========================
     AUTH
  ========================= */
        useEffect(() => {
        const unsub = onAuthStateChanged(auth, user => {
          if (user) {
            setAuthReady(true);
          } else {
            setAuthReady(false);
          }
          setAuthChecked(true);
        });

        return () => unsub();
      }, []);



  /* =========================
     CARREGAR KPI
  ========================= */
  useEffect(() => {
    if (!authReady) return;

    async function carregar() {
      try {
        setLoadingKpi(true);
        setErro(null);

        const snap = await getDoc(doc(db, "kpis", kpiId));

        if (!snap.exists()) {
          setErro("KPI não encontrado");
          return;
        }

        const data = snap.data();

        if (data.tipoKPI !== "EVENTO") {
          setErro("Este KPI não é de registro de evento");
          return;
        }

        setKpi({ id: snap.id, ...data });
      } catch (e) {
        console.error(e);
        setErro("Erro ao carregar o KPI");
      } finally {
        setLoadingKpi(false);
      }
    }

    carregar();
  }, [kpiId, authReady]);

  /* =========================
     SALVAR EVENTO
  ========================= */
  async function salvar() {
    setErro(null);

    if (!authReady || !auth.currentUser) {
      setErro("Sessão ainda carregando. Aguarde um instante.");
      return;
    }

    if (!tipoRegistro || !descricao.trim()) {
      setErro("Preencha todos os campos obrigatórios");
      return;
    }

    if (tipoRegistro === "NC") {
  if (!classificacaoNC) {
    setErro("Informe o tipo de Não Conformidade");
    return;
  }

  if (!imagem) {
    setErro("Para Não Conformidade, a imagem é obrigatória");
    return;
  }
}


    try {
      setLoading(true);
     
      // 1️⃣ cria evento
               const agora = serverTimestamp();

              const eventoRef = await addDoc(collection(db, "kpi_eventos"), aplicarTenantAtual({
                // 🔹 DADOS BÁSICOS
                kpiId,
                tipoRegistro,

                // 🔹 NC
                classificacaoNC: tipoRegistro === "NC" ? classificacaoNC : null,

                descricao,

                // 🔹 STATUS INICIAL DO EVENTO
                status: "Aberta",

                // 🔹 CAMPOS DO FLUXO DE NC (INICIAM VAZIOS)
                referencia: null,
                classificacao: null,
                prazo: null,
                causa: null,
                acaoCorretiva: null,
                acaoPreventiva: null,
                tipoNC: null,

                // 🔹 ANEXO
                imagemUrl: null,

                // 🔹 RELAÇÃO COM USUÁRIO
                userId: auth.currentUser.uid,
                userNome: auth.currentUser.displayName || "Colaborador",

                // 🔹 CONTROLE DE TEMPO
                criadoEm: agora,
                atualizadoEm: agora
              }));


      // 2️⃣ upload seguro (RESUMABLE)
      if (imagem) {
            const imagemComprimida = await compressImage(imagem, {
              maxWidth: 1600,
              maxHeight: 1600,
              quality: 0.7
            });

            const caminho = `kpi_eventos/${eventoRef.id}/evidencia.jpg`;
            const imgRef = ref(storage, caminho);

            const uploadTask = uploadBytesResumable(
              imgRef,
              imagemComprimida,
              {
                contentType: "image/jpeg"
              }
            );

            await new Promise((resolve, reject) => {
              uploadTask.on(
                "state_changed",
                null,
                reject,
                async () => {
                  const imagemUrl = await getDownloadURL(uploadTask.snapshot.ref);
                  await updateDoc(eventoRef, { imagemUrl });
                  resolve();
                }
              );
            });
          }


      setSucesso(true);
    } catch (e) {
      console.error(e);
      setErro("Erro ao registrar evento");
    } finally {
      setLoading(false);
    }
  }

       /* =========================
     LOADING
        ========================= */
        if (authChecked && !authReady) {
        history.replace("/login");
        return null;
      }

      if (!authChecked || loadingKpi) {
        return (
          <>
            <Navbar />
            <div className="container mt-4 text-center">
              Carregando formulário...
            </div>
          </>
        );
      }



  /* =========================
     ERRO KPI
  ========================= */
  if (erro && !kpi) {
    return (
      <>
        <Navbar />
        <div className="container mt-4" style={{ maxWidth: 700 }}>
          <div className="alert alert-warning">
            <p>{erro}</p>
            <button
              className="btn btn-secondary"
              onClick={() => history.goBack()}
            >
              Voltar
            </button>
          </div>
        </div>
      </>
    );
  }

  /* =========================
     FORM
  ========================= */
  return (
    <>
      <Navbar />

      <div className="container mt-4" style={{ maxWidth: 700 }}>
        <h4>{kpi.nome}</h4>
        <p className="text-muted">{kpi.descricao}</p>

        {erro && <div className="alert alert-danger">{erro}</div>}

        {sucesso && (
          <div className="alert alert-success">
            Registro realizado com sucesso!
            <div className="mt-2">
              <button
                className="btn btn-success"
                onClick={() => history.push("/dashboard")}
              >
                OK
              </button>
            </div>
          </div>
        )}

        {!sucesso && (
          <>
            <select
            className="form-control mb-3"
            value={tipoRegistro}
            onChange={e => {
              setTipoRegistro(e.target.value);
              setClassificacaoNC("");
            }}
          >
            <option value="">Tipo de registro</option>
            <option value="OCORRENCIA">Ocorrência</option>
            <option value="NC">Não Conformidade</option>
            <option value="MELHORIA">Proposta de Melhoria</option>
            <option value="INSPECAO_AMBIENTES">Inspeção de Ambientes</option>
          </select>

          {tipoRegistro === "NC" && (
            <select
              className="form-control mb-3"
              value={classificacaoNC}
              onChange={e => setClassificacaoNC(e.target.value)}
            >
              <option value="">Classificação da NC</option>
              <option value="DIA_A_DIA">NC do dia a dia</option>
              <option value="AUDITORIA_INTERNA">Auditoria Interna</option>
              <option value="AUDITORIA_EXTERNA">Auditoria Externa</option>
            </select>
          )}



            <textarea
              className="form-control mb-3"
              rows={4}
              placeholder="Descreva o ocorrido"
              value={descricao}
              onChange={e => setDescricao(e.target.value)}
            />

            <input
                    type="file"
                    className="form-control mb-3"
                    accept="image/jpeg,image/png,image/webp"
                    onChange={e => {
                      const file = e.target.files[0];
                      if (!file) return;

                      // ❌ bloqueia qualquer coisa que não seja imagem
                      if (!file.type.startsWith("image/")) {
                        setErro("Somente imagens (JPG, PNG ou WEBP) são permitidas.");
                        e.target.value = "";
                        return;
                      }

                      setImagem(file);
                    }}
                  />


            <div className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-secondary"
                onClick={() => history.goBack()}
              >
                Cancelar
              </button>

              <button
                className="btn btn-success"
                onClick={salvar}
                disabled={loading || !authReady}
              >
                {loading ? "Salvando..." : "Registrar"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
